export enum FeatureToggle {
  SUB_REGION_MANAGEMENT = 'SUB_REGION_MANAGEMENT',
  CARC = 'CARC',
}
